import { DateTime } from "luxon";
import {
  Box,
  CircularProgress,
  Chip,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableHead
} from "@material-ui/core";
import { OpenInNewRounded } from "@material-ui/icons";
import { useGetConsultantHealthDeclarationsQuery } from "@graphql";
import { ErrorCard } from "@common";
import { openInNewWindow } from "@utils/openInNewWindow";

type Props = {
  consultantId: string;
};

export function HealthDeclarationList(props: Props) {
  const query = useGetConsultantHealthDeclarationsQuery({
    variables: {
      consultantId: props.consultantId
    },
    fetchPolicy: "network-only"
  });

  if (query.loading) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" minHeight="10rem">
        <CircularProgress size={32} />
      </Box>
    );
  }

  if (query.error) {
    return (
      <ErrorCard
        title="Cannot load data"
        message={query.error.message ?? "Unknown error"}
        elevation={0}
        variant="outlined"
        fullWidth
      />
    );
  }

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>Name</TableCell>
          <TableCell>Status</TableCell>
          <TableCell>Created</TableCell>
          <TableCell>Signed</TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {query.data.consultantHealthDeclarations.items.map((x) => {
          return (
            <TableRow
              hover
              style={{ cursor: "pointer" }}
              title="Visa i OneFlow"
              onClick={() => openInNewWindow(x.url)}
            >
              <TableCell>{x.name}</TableCell>

              <TableCell>
                <Chip
                  size="small"
                  label={x.status}
                  color={x.status === "signed" ? "primary" : "default"}
                  style={{ marginLeft: "auto" }}
                />
              </TableCell>

              <TableCell>{parseDate(x.createdAt)}</TableCell>

              <TableCell>{parseDate(x.signedAt)}</TableCell>

              <TableCell>
                <OpenInNewRounded fontSize="small" />
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}

function parseDate(x: string | Date | null): string {
  if (!x) {
    return "";
  }

  const date = DateTime.fromISO(x.toString());

  if (!date.isValid) {
    return "";
  }

  return date.toFormat("yyyy-MM-dd");
}
